module.exports = __webpack_public_path__ + "img/menu_back.8b32c511.svg";